import { hashPii } from '../../utils';

export async function getSnapchatPii(email?: string) {
  if (!email) {
    return {};
  }

  return { user_hashed_email: await hashPii(email) };
}
